export default __webpack_public_path__ + "static/media/procedure20240716.956d1807.jpg";